export default __webpack_public_path__ + "static/media/Yenepoya.f79c7073.png";